import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IGeofence } from '@obvious.tech/constellation'

export const Geofence = defineEntity('Geofence', {
  endpoint: 'geolocation/api/Geofence',
  schema: SNoop<IGeofence>(),
})
